<route>
{
  "name": "login",
  "meta": {
    "order": 1,
    "isVisible": false,
    "iconName": "mdi-home"
  }
}
</route>

<template>
  <v-row
    justify="center"
    align="center">
    <v-col
      sm=4>
  <RegisterMobile
    :registrationContent= "registrationContent"
    :activationContent= "activationContent"
    :timerValue= "timerValue"
    @onActivationContent= "$router.push('/')"/>
    </v-col>
  </v-row>
</template>

<script>
import RegisterMobile from '@/components/mobileRegister.vue'
export default {
  name: 'page-login',
  components: { RegisterMobile },
  layout: 'empty',
  data: () => ({
    timerValue: '120',
    registrationContent: {
      phoneRules: [
        v => !!v || 'شماره موبایل خود را وارد کنید',
        v => (/^[\u0600-\u06FF\s0-9]+$/.test(v) && v.length === 11) || '.شماره موبایل به درستی وارد نشده است'
      ],
      title: ' برای ورود یا ثبت نام شماره موبایل خو را وارد کنید ',
      phoneNumber: '091********',
      btnText: 'ورود / ثبت نام'
    },
    activationContent: {
      codeRules: [
        v => !!v || 'کد موردنظر ۳۳۳۳ میباشد.',
        v => (/3333/.test(v) && v.length === 4) || 'کد وارد شده  درست نمیباشد'
      ],
      title1: '  کد ارسال شده به شماره ',
      title2: '  را وارد کنید.',
      phoneNumber: '****',
      btnText: 'تایید کد فعال سازی',
      resendCode: 'ارسال دوباره کد فعالسازی'
    }
  }),
  methods: {
    onRegisteration () {
    }
  }
}
</script>
